// src/useStore.ts
import { create } from 'zustand'
import { IChild, IDetails, IParent } from '../types/list.interface'
import { createJSONStorage, persist } from 'zustand/middleware'

interface Store {
  list: IChild[] | undefined
  setList: (list: IChild[] | undefined) => void
  details: IDetails | undefined
  setDetails: (details: IDetails | undefined) => void
  ids: string[]
  setIds: (ids: string[]) => void
  fullData: IParent | undefined
  setFullData: (fullData: IParent) => void
}

const useListStore = create<Store>()(
  persist(
    (set) => ({
      list: undefined,
      setList: (list) => set({ list }),
      details: undefined,
      setDetails: (details) => set({ details }),
      ids: [],
      setIds: (ids) => set({ ids }),
      fullData: undefined,
      setFullData: (fullData) => set({ fullData }),
    }),
    {
      name: 'user-list-store',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)

export default useListStore
